import { ThemeUICSSObject, responsive } from '@apia/theme';
/* IMPORT HERE */

const dateReasignment: ThemeUICSSObject = {
  '.modalButton': {
    width: '100% !important',
  },

  '.reasignmentForm__Container': {
    display: 'flex',
    gap: 3,
    flexDirection: responsive({ 0: 'column', 3: 'row' }),
  },
  '.changeDate__Wrapper': {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    '.changeDate__Input': {
      width: '230px',
    },
    gap: '4px',
  },
  '.changeDateData__Title': {
    color: 'palette.primary.main',
  },
  '.changeDateData__Additional': {
    display: 'flex',
    gap: '8px',
    flexDirection: responsive({ 0: 'column', 3: 'row' }),
  },
  '.changeDateData__AdditionalData': {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
  },
  '.changeDateData__Box': {
    border: '1px solid black',
    padding: '10px',
    margin: '10px',
  },
  '.changeDateData__ByReg': {
    paddingTop: '10px',
  },
};

export default dateReasignment;
